import { CSSProperties } from 'react';

import {
    columnarListGridCellStyle,
    getColumnarListGridMinWidth,
    getColumnarListGridStyle,
    getColumnarListGridTemplate,
} from '@/shared/components/lists/ColumnarListLayout';

export const getCompanySearchResultsGridTemplate = (listColumns: string[] = []) =>
    getColumnarListGridTemplate({ columnCount: listColumns.length });

export const getCompanySearchResultsMinWidth = (listColumns: string[] = []) =>
    getColumnarListGridMinWidth({ columnCount: listColumns.length });

export const getCompanySearchResultsGridStyle = (listColumns: string[] = []): CSSProperties =>
    getColumnarListGridStyle({ columnCount: listColumns.length });

export const companySearchResultsGridCellStyle: CSSProperties = columnarListGridCellStyle;
